import { Component, Input } from "@angular/core";
import { UpsellWhyContent } from "src/app/models/upsellWhyContent";

@Component({
  selector: "upsell-why",
  templateUrl: "upsell-why.html",
  styleUrls: ["upsell-why.scss"],
})

export class UpsellWhyComponent {

  @Input() upsellWhyContent: UpsellWhyContent[] = [];
  @Input() upsellWhyImage: string = 'https://cdn.badlandsranch.com/images/white-brown-dog.jpg';

  constructor() {}

  trackByFn(index: number, item: UpsellWhyContent): string | number {
    return item?.id || index;
  }
}